export type ParametersCsvField =
  | "orderName"
  | "orderId"
  | "returnRequestId"
  | "createdAt"
  | "shippedAt"
  | "status"
  | "returnCode"
  | "orderedAt"
  | "updatedAt"
  | "shippingAt"
  | "treatedLogisticianAt"
  | "treatedMerchantAt"
  | "pickupTiming"
  | "pickupTimingEnd"
  | "internalComments"
  | "comment"
  | "customerImages"
  | "returnToStoreExternalId";

export type ShippingAndCustomerFields =
  | "customerPhone"
  | "customerName"
  | "customerEmail"
  | "newVariantSku"
  | "lineItemId"
  | "shippingAddress1"
  | "shippingAddress2"
  | "shippingCity"
  | "shippingZip"
  | "shippingCountry"
  | "shippingCountryCode"
  | "shippingInfoCarrier"
  | "shippingInfoTrackingCode"
  | "customerId"
  | "customerFirstName"
  | "customerLastName"
  | "lang";

export type DataTreatmentCsvField =
  | "logisticianTreatedAt"
  | "merchantTreatedAt"
  | "assignedTo"
  | "logisticianValidated"
  | "logisticianRejected"
  | "logisticianReasonRejected"
  | "merchantValidated"
  | "merchantRejected"
  | "merchantReasonRejected"
  | "variantId"
  | "quantity"
  | "newVariantId"
  | "newVariantBarcode"
  | "locationId"
  | "newOrderName"
  | "externalStoreId";

export type ResultCsvField =
  | "sku"
  | "refunded"
  | "discounted"
  | "voucherCode"
  | "initialShippingRefund"
  | "returnShippingPaid"
  | "lineItemId"
  | "title"
  | "price"
  | "originalPrice"
  | "conversionRateCustomerOnShop"
  | "reasonId"
  | "reason"
  | "reasonExternalId"
  | "productId"
  | "quantityBought"
  | "variantTitle"
  | "variantBarcode"
  | "resolution"
  | "metafieldsVariant"
  | "metafieldsProduct"
  | "metafieldsOrder"
  | "customAttributesRR"
  | "rebuyAmount";

export const parametersFields: ParametersCsvField[] = [
  "orderId",
  "returnRequestId",
  "orderName",
  "returnCode",
  "createdAt",
  "orderedAt",
  "updatedAt",
  "shippedAt",
  "shippingAt",
  "treatedLogisticianAt",
  "treatedMerchantAt",
  "pickupTiming",
  "pickupTimingEnd",
  "status",
  "internalComments",
  "comment",
  "customerImages",
  "returnToStoreExternalId",
];

export const shippingAndCustomerFields: ShippingAndCustomerFields[] = [
  "customerPhone",
  "customerName",
  "customerEmail",
  "lineItemId",
  "newVariantSku",
  "shippingAddress1",
  "shippingAddress2",
  "shippingCity",
  "shippingZip",
  "shippingCountry",
  "shippingCountryCode",
  "shippingInfoCarrier",
  "shippingInfoTrackingCode",
  "customerId",
  "customerFirstName",
  "customerLastName",
  "lang",
];

export const dataTreatmentFields: DataTreatmentCsvField[] = [
  "logisticianTreatedAt",
  "merchantTreatedAt",
  "assignedTo",
  "logisticianValidated",
  "logisticianRejected",
  "logisticianReasonRejected",
  "merchantValidated",
  "merchantRejected",
  "merchantReasonRejected",
  "variantId",
  "quantity",
  "newVariantId",
  "newVariantBarcode",
  "locationId",
  "newOrderName",
  "externalStoreId",
];

export const resultFields: ResultCsvField[] = [
  "refunded",
  "discounted",
  "voucherCode",
  "initialShippingRefund",
  "returnShippingPaid",
  "rebuyAmount",
  "lineItemId",
  "sku",
  "title",
  "price",
  "originalPrice",
  "conversionRateCustomerOnShop",
  "reason",
  "reasonId",
  "reasonExternalId",
  "productId",
  "quantityBought",
  "variantTitle",
  "variantBarcode",
  "resolution",
  "metafieldsVariant",
  "metafieldsProduct",
  "metafieldsOrder",
  "customAttributesRR",
];

export type FieldsSections =
  | ParametersCsvField
  | ShippingAndCustomerFields
  | DataTreatmentCsvField
  | ResultCsvField;

export type SectionKeys =
  | "parameters"
  | "shippingCustomer"
  | "treatment"
  | "result";

export interface ExportReturnFieldsSection<T extends FieldsSections> {
  titleKey: SectionKeys;
  fields: T[];
}

export const exportReturnFieldsBySections: ExportReturnFieldsSection<FieldsSections>[] =
  [
    { titleKey: "parameters", fields: parametersFields },
    {
      titleKey: "shippingCustomer",
      fields: shippingAndCustomerFields,
    },
    {
      titleKey: "treatment",
      fields: dataTreatmentFields,
    },
    {
      titleKey: "result",
      fields: resultFields,
    },
  ];

export const exportReturnFields: Array<
  | ParametersCsvField
  | ShippingAndCustomerFields
  | DataTreatmentCsvField
  | ResultCsvField
> = [
  ...parametersFields,
  ...shippingAndCustomerFields,
  ...dataTreatmentFields,
  ...resultFields,
];
